import { Component, OnInit, Input } from '@angular/core'
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AdsTxtStatusConst } from 'src/app/planner/components/planner-edit/constants/AdsTxtStatus.const';
import * as _ from 'lodash';

@Component({
    selector: 'ads-txt-status',
    templateUrl: './ads-txt-status.component.html',
    styleUrls: ['./ads-txt-status.component.scss']
})
export class AdsTxtStatusComponent implements OnInit {

    @Input() group: string;
    @Input() formArray: FormArray;

    adsTxtStatuses: Array<any> = [];
    selectedStatusIds: Array<any> = [];
    selectedStatus: Array<any> = [];

    ngOnInit() {
        this.mapData();
    }

    onChange($event, statusId) {
        if ($event && $event.target && $event.target.checked) {
            this.selectedStatusIds.push(statusId)
        } else {
            this.selectedStatusIds = this.selectedStatusIds.filter(id => id !== statusId);
        }
        this.selectedStatus = _.filter(this.adsTxtStatuses, (status: any) => {
            return this.selectedStatusIds.findIndex((o: any) => { return o === status.id }) > -1;
        });
        this.adsTxtStatus.patchValue(_.map(this.selectedStatus, 'id'));
    }

    mapData() {
        _.forEach(AdsTxtStatusConst, (value: any, key: string) => {
            this.adsTxtStatuses.push(value);
        });
        this.selectedStatusIds = ((this.formArray.controls[this.group]) as FormGroup).controls.adsTxtStatuses.value;
        this.adsTxtStatuses.forEach((status) => {
            if (this.selectedStatusIds.includes(status.id)) {
                status.exist = true;
            } else {
                status.exist = false;
            }
        });
    }

    get adsTxtStatus(): FormControl {
        return this.formArray.controls[this.group].get('adsTxtStatuses');
    }

    get isDisabled(): boolean {
        return this.adsTxtStatus.disabled;
    }

}